module.exports = require('./helpers/bundle-url').getBundleURL('e4Pni') + "logo.c51670a8.svg";